import { useCallback, useEffect, useState } from 'react';

import { Job } from '~extension/web2print/model/Job';
import { MyFilesModal } from '~extension/web2print/view/MyFiles/MyFilesModal';
import useDelayFn from '~hooks/useDelayFn';

export function MyFilesModalController({ myFilesJob, onClose }: { myFilesJob: Job; onClose: () => void }) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // open my files modal if required parameters are given
  useEffect(() => {
    setIsOpen(Boolean(myFilesJob));
  }, [myFilesJob]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);

  return <MyFilesModal myFilesJob={myFilesJob} isOpen={isOpen} onClose={handleOnClose} />;
}
